module.exports = __webpack_public_path__ + "static/img/30010 (1).6c6a744.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30010 (1).webp
// module id = SiBn
// module chunks = 14